<main>
        <div class="contenedor">
            <!-- Header del proyecto -->
            <section class="header-proyecto">
                <div class="imagen-proyecto" style="background-image: url('https://res.cloudinary.com/dg7wvqxcv/image/upload/v1766881871/15-LINEA-AMARILLA-DSC_0533-1_ueevu7.jpg');"></div>
                <div class="titulo-con-flecha">
                    <a routerLink="/portafolio" class="btn-regreso">
                        <img src="assets/svg/flecha.svg" alt="Regresar">
                    </a>
                    <h1 class="titulo-proyecto">Línea Amarilla – Vía Expresa Río Verde / Vía Parque Rímac</h1>
                </div>
                <div class="cuadro_ubicacion">
                    <div class="ubicacion-proyecto">
                    <span class="icono-ubicacion"><img src="assets/svg/IconoMap.svg" alt=""></span>
                        Lima Metropolitana
                    </div>
                </div>
                
            </section>

            <!-- Seccié³n de informacié³n del proyecto -->
            <section class="seccion-info-proyecto">
                <div class="grid-info">
                    <div class="info-columna">
                        <h3>Importancia</h3>
                        <p>Obra de transporte urbano vital para la conectividad entre el norte, centro y este de Lima. Reduce significativamente los tiempos de viaje y mejora la fluidez vehicular.</p>
                    </div>
                    <div class="separador-vertical"></div>
                    <div class="info-columna">
                        <h3>Descripción del proyecto</h3>
                        <p>Incluye un túnel de 2 km bajo el río Rímac, 9 viaductos, 10 km de vía rápida y obras de drenaje y defensa ribereña.</p>
                    </div>
                </div>
            </section>

            <!-- Seccié³n de participacié³n -->
            <section class="seccion-participacion">
                <div class="contenido-participacion">
                    <div class="circulo-azul-decorativo"></div>
                    <div class="info-participacion">
                        <h2>Participación de Corporación Rehobot</h2>
                        <p>Se realizaron estudios hidrogeológicos, trámites y ejecución de obras especializadas para el abastecimiento del recurso hídrico subterráneo, en cumplimiento de los lineamientos técnicos y normativos del proyecto.</p>
                    </div>
                    <div class="imagen-participacion"></div>
                </div>
            </section>

            <!-- Sección de actividades -->
            <section class="seccion-actividades">
                <h2 class="actividades-titulo">Actividades <span>desarrolladas.</span></h2>
                <div class="contenido-actividades">
                    <div class="tarjeta-actividad">
                    </div>
                    <div class="tarjeta-lista-actividades">
                        <ul class="lista-actividades">
                            <li><strong>Elaboración del estudio hidrogeológico</strong> y gestión integral para la <strong>obtención de la autorización de perforación ante la ANA.</strong></li>
                            <li><strong>Perforación de un pozo para captación de aguas subterráneas</strong>, diseñado en base a los lineamientos de SEDAPAL, como pozo de reemplazo entregado a dicha entidad.</li>
                            <li><strong>Perforación de un pozo en el Parque de la Muralla</strong>, proyectado para el abastecimiento del recurso hídrico del parque y complementario para la construcción de la vía bajo el río Rímac.</li>
                        </ul>
                    </div>
                </div>
            </section>

            <!-- Sección Más proyectos -->
            <section class="seccion-mas-proyectos">
              <div class="divisor-linea"></div>
              <h2 class="mas-proyectos-titulo">Más <span>proyectos.</span></h2>

              <div class="grid-mas-proyectos">
                <div class="tarjeta-obra-mini" *ngFor="let obra of proyectosRecomendados">
                  <div class="imagen-obra-mini"
                       [style.backgroundImage]="'url(' + obra.imagen + ')'">
                  </div>
                  <div class="contenido-mini">
                    <h3>{{ obra.titulo }}</h3>
                    <a [routerLink]="obra.link" class="btn-conoce-mas">Conoce más</a>
                  </div>
                </div>
              </div>
            </section>
        </div>
    </main>